import React from 'react';
import ReactDOM from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import App from './App';

// Initialize Datadog RUM
datadogRum.init({
    applicationId: '96c428e1-08f3-4e1e-8354-a922dadacf36',
    clientToken: 'pub16573bbb10105ea106aba4904e18aef1',
    site: 'datadoghq.com',
    service:'workout-web',
    env: 'nonprod',
    
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate:  100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'allow',
    plugins: [reactPlugin({ router: true })],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
